/** PayNow bill reference practical max (bank apps / EMVCo). */
export const PAYNOW_REF_MAX = 25;

/**
 * Build PayNow reference: {ProgrammeNoDash}{Intake}{NameParts}
 *
 * Examples:
 * - DCG + 45 + "Morilla Judy Lozares" → DCG45MorillaJudyLozares
 * - DHRM-EL + 11 + "Jess Chua" → DHRMEL11JessChua
 *
 * - Dashes removed from programme code; letters after the dash are kept
 * - Each name word is PascalCase letters only
 * - Truncated to 25 characters (name shortened first)
 */
export function buildPayNowReference({
    programmeCode = '',
    intake = '',
    participantName = '',
} = {}) {
    const prog = String(programmeCode || '')
        .replace(/-/g, '')
        .replace(/[^a-zA-Z0-9]/g, '')
        .toUpperCase();

    const intakeStr =
        intake !== null && intake !== undefined && String(intake).trim() !== ''
            ? String(intake).replace(/[^a-zA-Z0-9]/g, '')
            : '';

    const namePart = String(participantName || '')
        .trim()
        .split(/\s+/)
        .filter(Boolean)
        .map((word) => {
            const letters = word.replace(/[^a-zA-Z]/g, '');
            if (!letters) return '';
            return letters.charAt(0).toUpperCase() + letters.slice(1).toLowerCase();
        })
        .join('');

    const prefix = `${prog}${intakeStr}`;
    if (!prefix && !namePart) return '';

    const maxNameLen = Math.max(0, PAYNOW_REF_MAX - prefix.length);
    return `${prefix}${namePart.slice(0, maxNameLen)}`.slice(0, PAYNOW_REF_MAX);
}
